module.exports = __webpack_public_path__ + "media/images/logo-white-studio-3bf33871.png";